import { useEffect, useState } from "react";

import { getConfig } from "site-config";
import { fetchJSON } from "lib/fetch";

import { TAPIResponse } from "../types";
import { getOrderProductsSummary } from "./order-details.helpers";
import type { TOrderDetailsItemsSummaryResponse } from "./order-details.helpers";
import { TOrderDetails } from "./order-details.type";
import { API_STATES } from "../helpers";
import { showAPIExceptionMessage } from "../api-exception-messages";

export type TParams = {
    enabled: boolean;
    orderId: string;
    snackbar: any;
};

interface IOrderDetails<Params, Response> {
    (params: Params): Response;
    getOrderProductsSummary: (upcField: string, orderDetails?: TOrderDetails) => TOrderDetailsItemsSummaryResponse;
}

export const useFetchOrderDetails: IOrderDetails<TParams, TAPIResponse<TOrderDetails, string>> = (params) => {
    const config = getConfig();
    const URL = `${config.api}/api/v3.0/order/${params.orderId}?__fields=__all&__populate=__item&__meta=true`;

    const [state, setState] = useState<TAPIResponse<TOrderDetails, string>>(API_STATES.default);

    const APIStates = API_STATES.getStates(setState);

    useEffect(() => {
        if (params.enabled) {
            APIStates.pending();
            fetchJSON<TOrderDetails>(URL, { method: "GET" })
                .then(APIStates.success)
                .catch((error) => {
                    showAPIExceptionMessage({ snackbar: params.snackbar });
                    APIStates.error(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.enabled]);

    return state;
};

useFetchOrderDetails.getOrderProductsSummary = getOrderProductsSummary;
